export default {
  mounted() {
    const inputElements = document.querySelectorAll("input");
    inputElements.forEach((input) => {
      input.setAttribute("autocomplete", "off");
    });
  },
};
